import { createContext, useContext } from 'react';
import { Theme, Interpolation } from '@emotion/react';

export type CalendarDragState = {
  /** True when this event card is the source being dragged (stays in its grid cell). */
  isEventCardOverlay: boolean;
  /** True when this event card is being rendered inside the floating DragOverlay ghost. */
  isEventDragOverlay: boolean;
  /** True when this event card is rendered as the drop-position placeholder. */
  isEventDropOverlay: boolean;
  /** Resolved styles for the event card wrapper, set by EventRenderer. */
  eventCardOverlayStyle: Interpolation<Theme> | undefined;
  /** Resolved styles for the drag overlay wrapper, set by EventDragOverlay. */
  eventDragOverlayStyle: Interpolation<Theme> | undefined;
  /** Resolved styles for the drop placeholder wrapper, set by EventDropPlaceholder. */
  eventDropOverlayStyle: Interpolation<Theme> | undefined;
  /** True when the enclosing column body is the active drop target during event drag. */
  isEventDropColumn: boolean;
  /** True when this column header is the source being reorder-dragged. */
  isColumnHeaderOverlay: boolean;
  /** True when this column header is being rendered inside the floating reorder DragOverlay ghost. */
  isColumnHeaderDragOverlay: boolean;
  /** Resolved styles for the column header wrapper, set by SortableColumnHeader. */
  columnHeaderOverlayStyle: Interpolation<Theme> | undefined;
  /** Resolved styles for the column header drag overlay wrapper, set by ColumnGroupSectionsDndWrapper. */
  columnHeaderDragOverlayStyle: Interpolation<Theme> | undefined;
};

export const defaultCalendarDragState: CalendarDragState = {
  isEventCardOverlay: false,
  isEventDragOverlay: false,
  isEventDropOverlay: false,
  eventCardOverlayStyle: undefined,
  eventDragOverlayStyle: undefined,
  eventDropOverlayStyle: undefined,
  isEventDropColumn: false,
  isColumnHeaderOverlay: false,
  isColumnHeaderDragOverlay: false,
  columnHeaderOverlayStyle: undefined,
  columnHeaderDragOverlayStyle: undefined,
};

export const CalendarDragStateContext = createContext<CalendarDragState>(defaultCalendarDragState);

export const useCalendarDragState = () => useContext(CalendarDragStateContext);
